module.exports = __webpack_public_path__ + "static/media/01.1d1859b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/01.jpg
// module id = 691
// module chunks = 0